import { Component, EventEmitter, Input, Output } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { HeadingComponentConfig, HeadingType } from '@rappider/rappider-components/utils';
import { WorkflowEvent, WorkflowEventPartial } from '@rappider/rappider-sdk';
import { EventMode } from '../../utils/event-mode.enum';

@Component({
  selector: 'rappider-workflow-event-wrapper',
  templateUrl: './workflow-event-wrapper.component.html',
  styleUrls: ['./workflow-event-wrapper.component.scss'],
})

export class WorkflowEventWrapperComponent {
  @Input() eventMode: EventMode;
  @Input() workflowEvent: WorkflowEvent;
  @Input() submitButtonLoading: boolean;
  @Input() cancelButtonLoading: boolean;
  @Input() workflowEventDeleteAllWorkflowConfig;

  @Output() createWorkflowEvent = new EventEmitter<WorkflowEventPartial>();
  @Output() editWorkflowEvent = new EventEmitter<WorkflowEventPartial>();
  @Output() eventNameChange = new EventEmitter<string>();
  @Output() deleteWorkflow = new EventEmitter();
  @Output() deleteEvent = new EventEmitter();

  EventMode = EventMode;
  workflowWrapperHeading: HeadingComponentConfig = {
    content: 'Workflow Event',
    type: HeadingType.H4
  };

  onCreateWorkflowEventFormSubmit(workflowEvent: WorkflowEventPartial) {
    this.createWorkflowEvent.emit(workflowEvent);
  }

  onEditWorkflowEventFormSubmit(workflowEvent: { workflowEventId: string; workflowEventBody?: WorkflowEventPartial }) {
    this.editWorkflowEvent.emit(workflowEvent);
  }

  onEventNameChange(name: string) {
    this.eventNameChange.emit(name);
  }

  onDeleteWorkflow(eventId) {
    this.deleteWorkflow.emit(eventId);
  }

  onDeleteEvent(eventId) {
    this.deleteEvent.emit(eventId);
  }
}
